// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__UlGCD","spinnerIcon":"Spinner_spinnerIcon__xae+U","spin3d":"Spinner_spin3d__wAfQa"};